import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "recent-transactions-section"
};
const _hoisted_2 = { class: "section-title" };
const _hoisted_3 = ["src"];
import { computed } from 'vue';
import TransactionsList from './TransactionsList.vue';
import { sortTransactionGroup } from '@/utils/helpers';
export default /*@__PURE__*/ _defineComponent({
    __name: 'RecentTransactionsSection',
    props: {
        transactions: {},
        formatter: {},
        today: {},
        yesterday: {},
        accountType: { default: 'all' },
        accountIds: { default: () => [] },
        updatingTransactionId: {},
        onTransactionClick: {},
        categoryPills: { type: Boolean },
        title: {},
        limit: { default: 2 },
        currentTransactionId: {}
    },
    emits: ["view-more", "refreshTransaction"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const accountTypeTitle = computed(() => {
            const titles = {
                'all': 'Recent',
                'current': 'Current Account',
                'credit': 'Credit Card',
                'savings': 'Savings Account'
            };
            return titles[props.accountType] || 'Recent';
        });
        // `title` overrides the auto-derived "<accountType> transactions" heading.
        const resolvedTitle = computed(() => props.title ?? `${accountTypeTitle.value} transactions`);
        // When no accountIds are provided we skip the account filter — the parent has
        // already curated the list (e.g. filtered to a single merchant).
        const filterByAccount = computed(() => (props.accountIds?.length ?? 0) > 0);
        const dateCounts = computed(() => {
            if (!props.transactions || props.transactions.length === 0 || !filterByAccount.value) {
                return {};
            }
            const counts = {};
            for (const group of props.transactions) {
                if (group.length === 0)
                    continue;
                const dateString = group[0].timestampString;
                let count = 0;
                for (const transaction of group) {
                    if (props.accountIds.includes(transaction.bankAccountID)) {
                        count++;
                    }
                }
                if (count > 0) {
                    counts[dateString] = count;
                }
            }
            return counts;
        });
        const totalCount = computed(() => {
            if (!props.transactions)
                return 0;
            let count = 0;
            for (const group of props.transactions) {
                for (const t of group) {
                    if (filterByAccount.value && !props.accountIds.includes(t.bankAccountID))
                        continue;
                    count++;
                }
            }
            return count;
        });
        const hasMore = computed(() => totalCount.value > props.limit);
        const limitedTransactions = computed(() => {
            if (!props.transactions || props.transactions.length === 0)
                return [];
            const max = props.limit;
            const limited = [];
            let count = 0;
            for (const group of props.transactions) {
                const sorted = sortTransactionGroup(group);
                const groupTransactions = [];
                for (const transaction of sorted) {
                    if (filterByAccount.value && !props.accountIds.includes(transaction.bankAccountID))
                        continue;
                    if (count >= max)
                        break;
                    groupTransactions.push(transaction);
                    count++;
                }
                if (groupTransactions.length > 0)
                    limited.push(groupTransactions);
                if (count >= max)
                    break;
            }
            return limited;
        });
        return (_ctx, _cache) => {
            return (limitedTransactions.value && limitedTransactions.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("h3", _hoisted_2, _toDisplayString(resolvedTitle.value), 1),
                    _createVNode(TransactionsList, {
                        transactions: limitedTransactions.value,
                        formatter: _ctx.formatter,
                        today: _ctx.today,
                        yesterday: _ctx.yesterday,
                        showDate: true,
                        showDateTotal: false,
                        search: false,
                        dividingLines: true,
                        dateCounts: dateCounts.value,
                        updatingTransactionId: _ctx.updatingTransactionId,
                        onTransactionClick: _ctx.onTransactionClick,
                        categoryPills: _ctx.categoryPills,
                        currentTransactionId: _ctx.currentTransactionId,
                        onRefreshTransaction: _cache[0] || (_cache[0] = (id) => emit('refreshTransaction', id))
                    }, null, 8, ["transactions", "formatter", "today", "yesterday", "dateCounts", "updatingTransactionId", "onTransactionClick", "categoryPills", "currentTransactionId"]),
                    (hasMore.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "view-more",
                            onClick: _cache[1] || (_cache[1] = ($event) => (emit('view-more')))
                        }, [
                            _cache[2] || (_cache[2] = _createTextVNode(" View more ")),
                            _createElementVNode("img", {
                                class: "arrow",
                                src: require('@/assets/arrow-right.png')
                            }, null, 8, _hoisted_3)
                        ]))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
